module.exports = __webpack_public_path__ + "static/img/img(20).372b415.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(20).png
// module id = 6tV6
// module chunks = 1